// extracted by mini-css-extract-plugin
module.exports = {"main":"SliderButton_main__3Y0dU"};